var map = {
	"./1_camera.svg": "858e",
	"./1_camera_and_episodes.svg": "a0a6",
	"./2_cameras_and_episodes.svg": "dc9a",
	"./3_cameras_and_episodes.svg": "9183",
	"./4_cameras.svg": "6386",
	"./4_cameras_and_episodes.svg": "ab6a",
	"./6_cameras.svg": "73fe",
	"./9_cameras.svg": "ac10",
	"./add.svg": "46e0",
	"./arrow-left.svg": "7947",
	"./arrow-right.svg": "387d",
	"./arrows-up-down.svg": "a60b",
	"./attach.svg": "f39c5",
	"./authenticate.svg": "54eb6",
	"./block.svg": "4d27",
	"./camera-group.svg": "1203",
	"./camera.svg": "3f87",
	"./cancel.svg": "2ec0",
	"./car.svg": "180c",
	"./car2.svg": "8562",
	"./card-add.svg": "89ba",
	"./card-view.svg": "33cb",
	"./cards.svg": "2d1c",
	"./change-lang.svg": "b969",
	"./change-theme.svg": "6f0d",
	"./check.svg": "b7dc",
	"./chevron-down.svg": "229d",
	"./chevron-down__padding_none.svg": "7446",
	"./chevron-left.svg": "1104",
	"./chevron-right.svg": "eb6e",
	"./cibr.svg": "97b7",
	"./circle-big.svg": "7c40",
	"./circle.svg": "5af0",
	"./close.svg": "d1ba",
	"./close_small.svg": "09fc",
	"./clusters.svg": "9c9d",
	"./computer.svg": "90c6",
	"./configure.svg": "864c",
	"./connection.svg": "f1aa",
	"./copy.svg": "0822",
	"./create-report.svg": "9f7f0",
	"./data-sources-next.svg": "4cf8",
	"./data-sources/ds-back.svg": "7059",
	"./data-sources/ds-f.svg": "7f9b",
	"./data-sources/ds-mirror.svg": "c2a8",
	"./data-sources/ds-rotate-left.svg": "7eb2",
	"./data-sources/ds-rotate-right.svg": "3ce6",
	"./delete.svg": "5752",
	"./done-all.svg": "6604",
	"./download.svg": "2046",
	"./edit.svg": "4c0b",
	"./empty.svg": "7df4",
	"./episodes.svg": "a215",
	"./eraser.svg": "bbff",
	"./error.svg": "ffc9",
	"./events.svg": "aa10",
	"./eye-closed.svg": "fbd1",
	"./eye-open.svg": "890d",
	"./face-square.svg": "f7ee",
	"./face.svg": "4dde",
	"./failure.svg": "fe93",
	"./favorite-outline.svg": "9616",
	"./file-broken.svg": "6f3b",
	"./file.svg": "fd2d",
	"./filter.svg": "e7dc",
	"./folder.svg": "c10e",
	"./fullscreen-exit.svg": "7c67",
	"./fullscreen.svg": "ebb8",
	"./id.svg": "aab9",
	"./info.svg": "536b",
	"./items.svg": "6a26",
	"./logout.svg": "33b6",
	"./main-picture.svg": "155b",
	"./minus.svg": "22c6",
	"./more-vertical.svg": "28e4",
	"./more.svg": "7723",
	"./mute.svg": "ae11",
	"./n-select/more.svg": "74b3",
	"./n-select/select_checkbox.svg": "85d2",
	"./pages/counters.svg": "8806",
	"./participants/participant-add.svg": "5bda",
	"./participants/participant-create.svg": "e829",
	"./person.svg": "c024",
	"./photo.svg": "d949",
	"./pin.svg": "3e35",
	"./play-outline.svg": "0a7c",
	"./play-processing.svg": "bdec",
	"./play.svg": "304d",
	"./player/backward-15.svg": "344b",
	"./player/backward-60.svg": "01ae",
	"./player/detect-auto.svg": "b1d8",
	"./player/detect-body.svg": "fab20",
	"./player/detect-face.svg": "b94b",
	"./player/forward-15.svg": "65a0",
	"./player/forward-60.svg": "cb5b",
	"./player/live-mode.svg": "ec21",
	"./player/pause.svg": "d195",
	"./player/play.svg": "8350",
	"./player/scroll-left.svg": "f00a",
	"./player/scroll-right.svg": "caef",
	"./player/vp-close-panel.svg": "6189",
	"./player/vp-dialog-close.svg": "5710",
	"./player/vp-info.svg": "355d",
	"./player/vp-ptz.svg": "469e",
	"./player/vp-settings.svg": "54d8",
	"./player/vp_backward_15.svg": "daad",
	"./player/vp_backward_60.svg": "f66c",
	"./player/vp_camera_next.svg": "ebc0",
	"./player/vp_camera_prev.svg": "bf21b",
	"./player/vp_download.svg": "6f21",
	"./player/vp_event_next.svg": "71dd",
	"./player/vp_event_prev.svg": "72b1",
	"./player/vp_forward_15.svg": "cb64",
	"./player/vp_forward_60.svg": "a080",
	"./player/vp_fullscreen_enter.svg": "ffad",
	"./player/vp_fullscreen_off.svg": "18fe",
	"./player/vp_live.svg": "21ee",
	"./player/vp_pause.svg": "139a",
	"./player/vp_photo.svg": "5c00",
	"./player/vp_play.svg": "7f3d",
	"./player/zoom-in.svg": "ed59",
	"./player/zoom-out.svg": "d263",
	"./player/zoom_minus.svg": "f4a7",
	"./player/zoom_plus.svg": "c06b",
	"./preferences.svg": "306c",
	"./process.svg": "d912",
	"./refresh.svg": "34b0",
	"./relations.svg": "5995",
	"./revert.svg": "a2c3",
	"./right-column.svg": "1da6",
	"./ring-unmute.svg": "280e",
	"./ring.svg": "58c8",
	"./roles.svg": "c47a",
	"./row-view.svg": "0168",
	"./scroll-up.svg": "2abe",
	"./search-wrapped.svg": "566f",
	"./search.svg": "d49d",
	"./select-all.svg": "6f2b",
	"./select.svg": "3f51",
	"./show-events.svg": "09ac",
	"./smartphone.svg": "a954",
	"./star.svg": "5983a",
	"./stop-processing.svg": "4d2e",
	"./stop.svg": "46f8",
	"./success.svg": "7e0f",
	"./table-actions/table-action-edit.svg": "7a15",
	"./table-actions/table-action-refresh.svg": "7b3e",
	"./table-actions/table-action-trash.svg": "2b7e",
	"./trash.svg": "149e",
	"./unknown.svg": "e9d2",
	"./unmute.svg": "d4fa",
	"./upload.svg": "1051",
	"./user.svg": "b1f3",
	"./users.svg": "d064",
	"./vector.svg": "b74e5",
	"./videos.svg": "e993",
	"./view-outline.svg": "1fce",
	"./vms.svg": "a69e",
	"./warning.svg": "fbf8",
	"./webhook.svg": "6d12"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "3967";